import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import ClientePacSelection from './ClientePacSelection';

class ClientePacsForm extends Component {
  state = {};

  get options() {
    return [
      {
        value: '',
        label: 'Selecciona',
      },
      {
        value: 'auto',
        label: 'Automática',
      },
      {
        value: 'manual',
        label: 'Manual',
      },
    ];
  }

  handleOnChange = (value) => {
    const { data } = this.props;

    const newData = {
      ...data,
      ...value,
    };

    const event = {
      data: newData,
      step: this.props.step,
      isValid: !!newData.pacs && newData.pacs.length > 0,
    };

    this.props.onFormDataChange(event);
  };

  handleOnPacSelectionChange = (value) => {
    this.handleOnChange({
      pacs: value,
    });
  };

  render() {
    const { data } = this.props;

    return (
      <Form>
        <FormControl
          type="select"
          label="Tipo de integración"
          name="tipo_integracion"
          placeholder=""
          help=""
          value={data.tipo_integracion}
          options={this.options}
          onChange={this.handleOnChange}
        />

        <ClientePacSelection
          pacs={data.pacs ?? {}}
          onChange={this.handleOnPacSelectionChange}
        />
      </Form>
    );
  }
}

export default ClientePacsForm;
